module.exports = __webpack_public_path__ + "img/pay.0d7d3d68.svg";